// 库位编码只展示“】-”后的实际库位部分，例如【A2.1.2-1】-4-1-1展示为4-1-1。
export function getShortGridNumber(gridNumber) {
  const value = String(gridNumber || '')
  const separatorIndex = value.indexOf('】-')
  return separatorIndex === -1 ? value : value.slice(separatorIndex + 2)
}

// 配送单列表、装箱信息和打印清单统一展示“区域用途编码-库位编号”。
export function getAreaGridName(areaTypeCode, gridNumber) {
  return [areaTypeCode, getShortGridNumber(gridNumber)]
    .filter(value => value || value === 0)
    .join('-')
}
